<template>
	<div class="wwei_staticcode_box">
		<div class="wwei_staticcode_topbar">
			<div class="wwei_staticcode_topbar_item" @click="topChange(1)"
				:class="{wwei_staticcode_topbar_item_selected:topCurrent==1,}">
				<span class="mbm-iconfont mbm-textEdit mbm-top-icon"></span>
				免费文本
			</div>
			<div class="wwei_staticcode_topbar_item" @click="topChange(2)"
				:class="{wwei_staticcode_topbar_item_selected:topCurrent==2,}">
				<span style="font-size: 16px;" class="mbm-iconfont mbm-wangzhi1 mbm-top-icon"></span>
				网址
			</div>
			<div class="wwei_staticcode_topbar_item" @click="topChange(3)"
				:class="{wwei_staticcode_topbar_item_selected:topCurrent==3,}">
				<span style="font-size: 18px;" class="mbm-iconfont mbm-lianxiren mbm-top-icon"></span>
				联系卡
			</div>
			<div class="wwei_staticcode_topbar_item" @click="topChange(4)"
				:class="{wwei_staticcode_topbar_item_selected:topCurrent==4,}">
				<span style="font-size: 17px;" class="mbm-iconfont mbm-shouji mbm-top-icon"></span>
				手机
			</div>
			<div class="wwei_staticcode_topbar_item" @click="topChange(5)"
				:class="{wwei_staticcode_topbar_item_selected:topCurrent==5,}">
				<span class="mbm-iconfont mbm-duanxin mbm-top-icon"></span>
				短信
			</div>
			<div class="wwei_staticcode_topbar_item" @click="topChange(6)"
				:class="{wwei_staticcode_topbar_item_selected:topCurrent==6,}">
				<span style="font-size: 16px;" class="mbm-iconfont mbm-wifi mbm-top-icon"></span>
				WIFI
			</div>
			<div class="wwei_staticcode_topbar_item" @click="topChange(7)"
				:class="{wwei_staticcode_topbar_item_selected:topCurrent==7,}">
				<span style="font-size: 13px;" class="mbm-iconfont mbm-youjian mbm-top-icon"></span>
				邮件
			</div>
		</div>
		<div class="wwei_staticcode_content">
			<div class="wwei_staticcode_content_input">
				<div class="wwei_staticcode_content_input_item" v-if="topCurrent==1"
					style="min-height:100%;height:auto;">
					<!-- 免费文本 -->
					<a-textarea @change="freeTextChange" :autoSize="{ minRows: 10, maxRows: 20 }" class="wwei_textarea" placeholder="请输入文本内容"
						:allowClear="true" :maxlength="500" v-model:value="freeText"></a-textarea>
				</div>

				<div class="wwei_staticcode_content_input_item" v-if="topCurrent==2">
					<!-- 网址 -->
					<div class="wwei_note_box">
						<div class="wwei_input_item">
							<span>网址</span><!-- <span style="color: red;margin-left: 2px;">*</span> -->
							<a-input class="wwei_note_input" @change="websiteChange" @pressEnter="websiteChange"
								placeholder="https:// 请输入网址" v-model:value="websiteText">
							</a-input>
						</div>
					</div>
				</div>
				<div class="wwei_staticcode_content_input_item" v-if="topCurrent==3">
					<!-- 联系卡 -->
					<div class="wwei_note_box wwei_contact_box ">

						<div class="wwei_contact_left">

							<div class="wwei_input_item">
								<span>姓名</span><span style="color: red;margin-left: 2px;">*</span>
								<a-input class="wwei_note_input" type="text" v-model:value="contactValue.name"
									@change="contactChange">
								</a-input>
							</div>
							<div class="wwei_input_item">
								<span>手机</span><span style="color: red;margin-left: 2px;">*</span>
								<a-input class="wwei_note_input" type="text" v-model:value="contactValue.phone"
									@change="contactChange">
								</a-input>
							</div>
							<div class="wwei_input_item">
								<span>家庭电话</span>
								<a-input class="wwei_note_input" type="text" v-model:value="contactValue.homePhone"
									@change="contactChange">
								</a-input>
							</div>
							<div class="wwei_input_item">
								<span>传真</span><span v-if="false" style="color: red;margin-left: 2px;">*</span>
								<a-input class="wwei_note_input" type="text" v-model:value="contactValue.fax"
									@change="contactChange">
								</a-input>
							</div>
							<div class="wwei_input_item">
								<span>邮箱</span><span v-if="false" style="color: red;margin-left: 2px;">*</span>
								<a-input class="wwei_note_input" type="text" v-model:value="contactValue.email"
									@change="contactChange">
								</a-input>
							</div>
							<div class="wwei_input_item">
								<span>个人简介</span><span v-if="false" style="color: red;margin-left: 2px;">*</span>
								<a-input class="wwei_note_input" type="text" v-model:value="contactValue.note"
									@change="contactChange">
								</a-input>
							</div>


							<!-- <div class="wwei_input_item" v-for="(item,index) in newContactList">
								<span>{{item.title}}</span><span v-if="false"
									style="color: red;margin-left: 2px;">*</span>
								<a-input class="wwei_note_input" v-model:value="item.value">
								</a-input>
								<span class="wwei_delete_btn" @click="deleteItem(index,1)">删除</span>
							</div> -->

							<!-- <a-dropdown :trigger="['click']" :placement="'bottomCenter'">

								<div class="wwei_contact_addItem" @click.prevent><span
										class="mbm-iconfont mbm-jia"></span>添加联系方式
								</div>

								<template #overlay>
									<a-menu style="width:100px;">
										<a-menu-item key="1" @click="newItem(1,1)">
											<a>邮箱</a>
										</a-menu-item>
										<a-menu-item key="2" @click="newItem(2,1)">
											<a>网址</a>
										</a-menu-item>
										<a-menu-item key="3" @click="newItem(3,1)">
											<a>传真</a>
										</a-menu-item>
										<a-menu-item key="4" @click="newItem(4,1)">
											<a>电话</a>
										</a-menu-item>
										<a-menu-item key="5" @click="newItem(5,1)">
											<a>微信</a>
										</a-menu-item>
										<a-menu-item key="6" @click="newItem(6,1)">
											<a>QQ</a>
										</a-menu-item>
										<a-menu-item key="7" @click="newItem(7,1)">
											<a>微博</a>
										</a-menu-item>
									</a-menu>
								</template>
							</a-dropdown> -->
						</div>

						<div class="wwei_contact_right">
							<div class="wwei_input_item">
								<span>公司</span>
								<a-input class="wwei_note_input" type="text" v-model:value="projectValue.name"
									@change="contactChange">
								</a-input>
							</div>
							<div class="wwei_input_item">
								<span>职位</span><span v-if="false" style="color: red;margin-left: 2px;">*</span>
								<a-input class="wwei_note_input" type="text" v-model:value="projectValue.position"
									@change="contactChange">
								</a-input>
							</div>
							<div class="wwei_input_item">
								<span>工作电话</span>
								<a-input class="wwei_note_input" type="text" v-model:value="projectValue.phone"
									@change="contactChange">
								</a-input>
							</div>
							<div class="wwei_input_item">
								<span>工作地址</span><span v-if="false" style="color: red;margin-left: 2px;">*</span>
								<a-input class="wwei_note_input" type="text" v-model:value="projectValue.address"
									@change="contactChange">
								</a-input>
							</div>
							<div class="wwei_input_item">
								<span>工作传真</span><span v-if="false" style="color: red;margin-left: 2px;">*</span>
								<a-input class="wwei_note_input" type="text" v-model:value="projectValue.fax"
									@change="contactChange">
								</a-input>
							</div>
							<div class="wwei_input_item">
								<span>网址</span><span v-if="false" style="color: red;margin-left: 2px;">*</span>
								<a-input class="wwei_note_input" type="text" v-model:value="projectValue.url"
									@change="contactChange">
								</a-input>
							</div>

							<!-- <div class="wwei_input_item" v-for="(item,index) in newProjectList">
								<span>{{item.title}}</span><span v-if="false"
									style="color: red;margin-left: 2px;">*</span>
								<a-input class="wwei_note_input" v-model:value="item.value">
								</a-input>
								<span class="wwei_delete_btn" @click="deleteItem(index,2)">删除</span>
							</div> -->

							<!-- <a-dropdown :trigger="['click']" :placement="'bottomCenter'">

								<div class="wwei_contact_addItem" @click.prevent><span
										class="mbm-iconfont mbm-jia"></span>添加项目
								</div>

								<template #overlay>
									<a-menu style="width:100px;">
										<a-menu-item key="1" @click="newItem(1,2)">
											<a>职位</a>
										</a-menu-item>
										<a-menu-item key="2" @click="newItem(2,2)">
											<a>头衔</a>
										</a-menu-item>
										<a-menu-item key="3" @click="newItem(3,2)">
											<a>地址</a>
										</a-menu-item>
										<a-menu-item key="4" @click="newItem(4,2)">
											<a>签名</a>
										</a-menu-item>
										<a-menu-item key="3" @click="newItem(3,1)">
											<a>传真</a>
										</a-menu-item>
									</a-menu>
								</template>
							</a-dropdown> -->
						</div>

					</div>
				</div>
				<div class="wwei_staticcode_content_input_item" v-if="topCurrent==4">
					<!-- 手机 -->
					<div class="wwei_note_box">
						<div class="wwei_input_item">
							<span>手机</span><span style="color: red;margin-left: 2px;">*</span>
							<a-input class="wwei_note_input" v-model:value="phone_phoneNumber" @change="phoneChange">
							</a-input>
						</div>
					</div>
				</div>
				<div class="wwei_staticcode_content_input_item" v-if="topCurrent==5">
					<!-- 短信 -->
					<div class="wwei_note_box">
						<div class="wwei_input_item" style="margin-bottom: 50px;">
							<span>手机</span><span style="color: red;margin-left: 2px;">*</span>
							<a-input class="wwei_note_input" v-model:value="note_phoneNumber" @change="noteChange">
							</a-input>
						</div>
						<div class="wwei_input_item">
							<span>短信内容</span><span v-if="false" style="color: red;margin-left: 2px;">*</span>
							<a-input class="wwei_note_input" v-model:value="noteContent" @change="noteChange">
							</a-input>
						</div>
					</div>


				</div>
				<div class="wwei_staticcode_content_input_item" v-if="topCurrent==6">
					<!-- WIFI -->
					<div class="wwei_note_box" style="padding-top:40px;">
						<div class="wwei_input_item" style="margin-bottom:25px">
							<span>无线上网ID</span><span style="color: red;margin-left: 2px;">*</span>
							<a-input class="wwei_note_input" v-model:value="wifiID" @change="wifiChange">
							</a-input>
						</div>
						<div class="wwei_input_item" style="margin-bottom:25px">
							<span>密码</span><span v-if="false" style="color: red;margin-left: 2px;">*</span>
							<a-input class="wwei_note_input" v-model:value="wifipwd" @change="wifiChange">
							</a-input>
						</div>
						<div style="margin-bottom:10px;">加密类型</div>
						<div class="wwei_input_item" style="border:none;">
							<a-select v-model:value="wifiType" style="width: 100%;" label-in-value size="large"
								:options="wifiTypeOptions" @change="wifiChange">
							</a-select>
						</div>
					</div>
				</div>
				<div class="wwei_staticcode_content_input_item" v-if="topCurrent==7">
					<!-- 邮件 -->
					<div class="wwei_note_box" style="padding-top:40px;">
						<div class="wwei_input_item" style="margin-bottom:25px">
							<span>电子邮件</span><span style="color: red;margin-left: 2px;">*</span>
							<a-input class="wwei_note_input" v-model:value="email" @change="emailChange">
							</a-input>
						</div>
						<div class="wwei_input_item" style="margin-bottom:25px">
							<span>邮件标题</span><span v-if="false" style="color: red;margin-left: 2px;">*</span>
							<a-input class="wwei_note_input" v-model:value="emailTitle" @change="emailChange">
							</a-input>
						</div>
						<div class="wwei_input_item">
							<span>邮件内容</span><span v-if="false" style="color: red;margin-left: 2px;">*</span>
							<a-input class="wwei_note_input" v-model:value="emailContent" @change="emailChange">
							</a-input>
						</div>
					</div>
				</div>
			</div>
			<div class="wwei_staticcode_content_bottom">
				<div>Ctrl</div>
				<div>S</div>保存图片
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'staticcode',
		components: {

		},

		data() {
			return {
				/* 顶部选中 */
				topCurrent: 1,
				/* 免费文本-start */
				freeText: '',
				/* 免费文本-end */
				/* 网址-start */
				websiteText: '',
				/* 网址-end */
				/* 联系卡-start */
				contactValue: {
					name: '',
					phone: '',
					homePhone: '',
					email: '',
					note: '',
					fax: '',
				},
				newContactList: [],
				projectValue: {
					name: '',
					position: '',
					phone: '',
					address: '',
					fax: '',
					url: '',
				},
				newProjectList: [],
				/* 联系卡-end */
				/* 手机-start */
				phone_phoneNumber: '',
				/* 手机-end */
				/* 短信-start */
				note_phoneNumber: '',
				noteContent: '',
				/* 短信-end */
				/* WIFI-start */
				wifiID: '',
				wifipwd: "",
				wifiType: {
					value: "WPA",
					label: 'WPA/WPA2',
				},
				wifiTypeOptions: [{
					value: "WPA",
					label: 'WPA/WPA2',
				}, {
					value: 'WEP',
					label: 'WEP',
				}, {
					value: 'nopass',
					label: '无加密',
				}, ],
				/* WIFI-end */
				/* 邮件-start */
				email: '',
				emailTitle: '',
				emailContent: '',
				/* 邮件-end */
			}
		},
		methods: {
			topChange(number) {
				this.topCurrent = number;
				switch (number) {
					case 1:
						this.freeTextChange();
						break;
					case 2:
						this.websiteChange();
						break;
					case 3:
						this.contactChange();
						break;
					case 4:
						this.phoneChange();
						break;
					case 5:
						this.noteChange();
						break;
					case 6:
						this.wifiChange();
						break;
					case 7:
						this.emailChange();
						break;
				}
			},
			newItem(e, type) {
				let item = {
					title: '',
					value: ''
				};
				if (type == 1) {
					switch (e) {
						case 1:
							item = {
								title: '邮箱',
								value: ''
							};
							break;

						case 2:
							item = {
								title: '网址',
								value: ''
							};
							break;
						case 3:
							item = {
								title: '传真',
								value: ''
							};
							break;
						case 4:
							item = {
								title: '电话',
								value: ''
							};
							break;
						case 5:
							item = {
								title: '微信',
								value: ''
							};
							break;
						case 6:
							item = {
								title: 'QQ',
								value: ''
							};
							break;
						case 7:
							item = {
								title: '微博',
								value: ''
							};
							break;
					}
					this.newContactList.push(item);
				} else if (type == 2) {
					switch (e) {
						case 1:
							item = {
								title: '职位',
								value: ''
							};
							break;
						case 2:
							item = {
								title: '头衔',
								value: ''
							};
							break;
						case 3:
							item = {
								title: '地址',
								value: ''
							};
							break;
						case 4:
							item = {
								title: '签名',
								value: ''
							};
							break;
					}
					this.newProjectList.push(item);
				}
			},
			deleteItem(index, type) {
				if (type == 1) {
					this.newContactList.splice(index, 1);
				} else if (type == 2) {
					this.newProjectList.splice(index, 1);
				}
			},

			freeTextChange(e) {
				this.$emit("changeContent", {
					qrcode_type: "text",
					topCurrent: 1,
					content: this.freeText,
				});
			},
			websiteChange(e) {
				this.$emit("changeContent", {
					qrcode_type: "text",
					topCurrent: 2,
					content: this.websiteText,
				});
			},
			contactChange() {
				let content = "BEGIN:VCARD\r\nVERSION:3.0";
				let contentIsEmpty = true;
				if (this.projectValue.url != '') {
					content += '\r\nURL:' + this.projectValue.url;
					contentIsEmpty = false;
				}
				if (this.contactValue.name != '') {
					content += '\r\nN:' + this.contactValue.name;
					contentIsEmpty = false;
				}
				if (this.contactValue.phone != '') {
					content += '\r\nTEL;CELL;VOICE:' + this.contactValue.phone;
					contentIsEmpty = false;
				}
				if (this.contactValue.homePhone != '') {
					content += '\r\nTEL;HOME;VOICE:' + this.contactValue.homePhone;
					contentIsEmpty = false;
				}
				if (this.contactValue.email != '') {
					content += '\r\nEMAIL:' + this.contactValue.email;
					contentIsEmpty = false;
				}
				if (this.contactValue.note != '') {
					content += '\r\nNOTE:' + this.contactValue.note;
					contentIsEmpty = false;
				}
				if (this.contactValue.fax != '') {
					content += '\r\nTEL;HOME;FAX:' + this.contactValue.fax;
					contentIsEmpty = false;
				}

				if (this.projectValue.name != '') {
					content += '\r\nORG:' + this.projectValue.name;
					contentIsEmpty = false;
				}
				if (this.projectValue.position != '') {
					content += '\r\nTITLE:' + this.projectValue.position;
					contentIsEmpty = false;
				}
				if (this.projectValue.phone != '') {
					content += '\r\nTEL;WORK;VOICE:' + this.projectValue.phone;
					contentIsEmpty = false;
				}
				if (this.projectValue.address != '') {
					content += '\r\nADR;WORK;POSTAL:' + this.projectValue.address;
					contentIsEmpty = false;
				}

				if (this.projectValue.fax != '') {
					content += '\r\nTEL;WORK;FAX:' + this.projectValue.fax;
					contentIsEmpty = false;
				}

				content += "\r\nEND:VCARD";
				if(contentIsEmpty){
					content = ''
				}
				this.$emit("changeContent", {
					qrcode_type: "text",
					topCurrent: 3,
					content: content,
				});
			},
			phoneChange() {
				let content = 'TEL:' + this.phone_phoneNumber
				if (this.phone_phoneNumber == '') {
					content = '';
				}
				this.$emit("changeContent", {
					qrcode_type: "text",
					topCurrent: 4,
					content: content,
				});
			},

			noteChange() {
				let content = 'SMSTO:' + this.note_phoneNumber + ':' + this.noteContent;
				if (this.note_phoneNumber == '' && this.noteContent== '') {
					content = '';
				}
				this.$emit("changeContent", {
					qrcode_type: "text",
					topCurrent: 5,
					content: content,
				});
			},

			wifiChange(e) {
				let content = 'WIFI:S:' + this.wifiID + ';T:' + this.wifiType.value + ';P:' + this.wifipwd + ';';
				if (this.wifiID == '' && this.wifipwd == '') {
					content = '';
				}
				this.$emit("changeContent", {
					qrcode_type: "text",
					topCurrent: 6,
					content: content,
				});
			},

			emailChange(e) {
				let content = 'MATMSG:TO:' + this.email + ';SUB:' + this.emailTitle + ';BODY:' + this.emailContent + ';;';
				if (this.email == '' && this.emailTitle == '' && this.emailContent == '') {
					content = '';
				}
				this.$emit("changeContent", {
					qrcode_type: "text",
					topCurrent: 7,
					content: content,
				});
			},
			// BEGIN:VCARD
			// VERSION:3.0
			// TEL;CELL;VOICE:13350986436
			// TEL;WORK;VOICE:13350986436
			// TEL;WORK;FAX:13350986436
			// URL:www.baidu.com
			// EMAIL:1648575130@qq.com
			// NOTE:发送到发送到发送到待审核
			// FN:FJS
			// ORG:中国
			// TITLE:菜鸡
			// ADR;WORK;POSTAL:天街
			// END:VCARD

			// analysisUrl(str) {
			// 	// if(!str){
			// 	//     return;
			// 	// }
			// 	//先计算里面有多少个需要替换的链接
			// 	if(str.indexOf("http://") == -1&&str.indexOf("https://") == -1){
			// 		str = "http://"+str;
			// 	}
			// 	return str;
			// },
		},
	}
</script>

<style>
	
	.wwei_staticcode_box {
		width: 100%;
		height: 100%;
		padding: 73px 0 0 0;
		box-sizing: border-box;
	}

	.wwei_staticcode_topbar {
		display: flex;
		align-items: center;
		justify-content: space-between;
		line-height: 1;
		padding: 0 50px;
		border-bottom: 1px solid #d9d9d9;
	}

	.wwei_staticcode_topbar_item {
		/* padding: 14px 0; */
		font-weight: 500;
		box-sizing: border-box;
		cursor: pointer;
		font-size: 14px;
		color: #585858;
		border-bottom: 2px solid transparent;
		margin-bottom: -1px;
		display: flex;
		align-items: center;
		height: 46px;
	}

	.mbm-top-icon {
		font-size: 18px;
		margin-right: 6px;
	}

	.wwei_staticcode_topbar_item:hover {
		color: #09bd71;
		border-color: #09bd71;
	}

	.wwei_staticcode_topbar_item_selected {
		color: #09bd71;
		border-color: #09bd71;
	}

	.wwei_staticcode_content {
		position: relative;
		min-height: calc(100% - 48px);
		width: 100%;
	}

	.wwei_staticcode_content_input {
		min-height: 100%;
		width: 100%;
	}

	.wwei_staticcode_content_input_item {
		width: 100%;
		height: 100%;
	}

	.wwei_staticcode_content_input_item::-webkit-scrollbar {
		display: none;
	}

	.wwei_staticcode_content_input_item .wwei_textarea {
		resize: none;
		font-size: 16px;
		outline: none;
		overflow: hidden;
	}

	.wwei_staticcode_content_input_item>.wwei_textarea {
		width: 100%;
		min-height: 100%;
		padding: 28px 38px !important;
		padding-bottom: 50px !important;
		border: none;
		box-sizing: border-box;


	}

	.wwei_note_box {
		padding: 90px 130px;
		padding-bottom: 0;
		box-sizing: border-box;
	}

	.wwei_input_item {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		border-bottom: 1px solid #d9d9d9;
	}

	.wwei_input_item:hover {
		border-color: #09bd71;
	}

	.wwei_delete_btn {
		color: #09bd71;
		cursor: pointer;
	}

	.wwei_delete_btn:hover {
		opacity: 0.8;
	}

	.wwei_note_box .wwei_note_input {
		flex: 1;
		padding: 14px 0;
		border: none;

		outline: none;
		margin-left: 10px;
	}

	.wwei_note_box .wwei_note_input:focus {

		border-right-width: 1px !important;
		outline: 0;
		box-shadow: none;
	}

	.wwei_note_box .wwei_note_input:hover {
		border-color: #09bd71;
		border-right-width: 1px !important;
		outline: 0;
		box-shadow: none;
	}

	.wwei_contact_box {
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		padding: 42px 80px;
		padding-bottom: 66px;
		box-sizing: border-box;
	}

	.wwei_contact_box>div {
		width: 323px;
	}

	.wwei_contact_addItem {
		margin-top: 24px;
		color: #09bd71;
		cursor: pointer;
		display: flex;
		align-items: center;
	}

	.wwei_contact_addItem:hover {
		opacity: 0.8;
	}

	.wwei_contact_addItem>span {
		font-size: 14px;
		margin-right: 4px;
	}

	.wwei_staticcode_content_bottom {
		position: absolute;
		right: 20px;
		bottom: 24px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		box-sizing: border-box;
		line-height: 1;
		font-size: 12px;
		color: #bfbfbf;
	}

	.wwei_staticcode_content_bottom>div {
		padding: 2px 4px;
		box-shadow: 0 0px 5px rgba(0, 0, 0, 9%);
		border-radius: 6px;
		font-size: 10px;
		/* background: #ffffff; */
	}

	.wwei_staticcode_content_bottom>div:first-child {
		margin-right: 4px;
	}

	.wwei_staticcode_content_bottom>div:last-child {
		margin-right: 10px;
	}
</style>
